<template>
    <v-card>
        <div class="mb-2">
            <v-btn-toggle
                v-model="expiredRoomFaresFilter"
                class="filter-btn-group"
                borderless
            >
                <v-btn
                    v-for="(filterData, index) in expiredRoomFaresFilterData"
                    :key="index"
                    :value="filterData.value"
                    color="white"
                    class="filter-btn"
                >
                    <span class="color-grey-onfly">{{ filterData.label }}</span>
                    <v-chip
                        v-if="filterData.counter"
                        small
                        label
                        :color="filterData.counterColor"
                        class="ml-2 counter-chip py-3"
                    >
                        {{ filterData.counter }}
                    </v-chip>
                </v-btn>
            </v-btn-toggle>
        </div>
        <v-data-table
            :footer-props="{itemsPerPageOptions:[1,5,10]}"
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="total"
            :loading="loading"
            class="elevation-0 dataTable pt-3"
        >

            <template
                v-slot:body.prepend="{ headers }"
            >
                <tr>
                    <td>
                        <v-text-field
                            v-model="hotelName"
                            label="Hotel..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()"
                        >
                        </v-text-field>
                    </td>
                    <td>
                        <v-text-field
                            v-model="hotelCity"
                            label="Cidade..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()">
                        </v-text-field>
                    </td>
                    <td></td>
                    <td>
                        <v-text-field
                            v-model="cnpj"
                            label="CNPJ..."
                            v-mask="'NN.NNN.NNN/NNNN-##'"
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()"
                        >
                        </v-text-field>
                    </td>
                    <td>
                        <v-text-field
                            v-model="creatorName"
                            label="Nome..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()">
                        </v-text-field>
                    </td>
                    <td>
                        <v-menu
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    class="mt-5"
                                    v-model="date"
                                    label="Data..."
                                    persistent-hint
                                    prepend-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dateCalendar"
                                range
                                no-title
                            ></v-date-picker>
                        </v-menu>
                    </td>
                    <td>
                        <v-select
                            class="mt-4"
                            v-model="active"
                            chips
                            :items="selects"
                            item-text="text"
                            item-value="value"
                            label="Situação do hotel"
                        ></v-select>
                    </td>
                    <td></td>
                    <td>
                        <v-select
                            class="mt-4"
                            v-model="expiredRoomFares"
                            chips
                            :items="expiredRoomFaresOptions"
                            item-text="text"
                            item-value="value"
                            label="Situação das Tarifas"
                        ></v-select>
                    </td>
                    <td></td>
                    <td class="text-center" >
                        <v-btn
                            class="mt-4"
                            depressed
                            color="primary"
                            width="80%"
                            v-on:click="getData()"
                        >
                            Buscar
                        </v-btn>
                        <v-btn
                            class="mt-4 mb-4"
                            depressed
                            color="#FBC02D"
                            width="80%"
                            v-on:click="getCleanFilter()"
                        >
                            Limpar
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:item.cnpj="{ item }">
                {{ getMaskedCnpj(item.cnpj) }}
            </template>
            <template v-slot:item.created_at="{ item }">
                {{ parseDate(item.created_at, 'DD/MM/YYYY H:mm') }}
            </template>
            <template v-slot:item.active="{ item }">
                <v-chip v-if="item.active === 1"
                        class="ma-2"
                        color="green"
                        text-color="white"
                >
                    {{ getActive(item) }}
                </v-chip>
                <v-chip v-if="item.active === 0 "
                        class="ma-2"
                        color="red"
                        text-color="white"
                >
                    {{ getActive(item) }}
                </v-chip>
            </template>
            <template v-slot:item.updated_at="{ item }">
                {{ getLastUpdateDate(item) }}
            </template>
            <template v-slot:item.has_expired_room_fares="{ item }">
                <v-tooltip top max-width="320" color="info">
                    <template v-slot:activator="{ on }" >
                        <v-chip
                            v-on="on"
                            class="ma-2"
                            label
                            outlined
                            :color="getListHotelsFareStatusBadgeColor(item)"
                        >
                            {{ getListHotelsFareStatusBadgeLabel(item) }}
                        </v-chip>
                    </template>
                    <span>
                        {{ getListHotelsFareStatusBadgeTooltipLabel(item) }}
                    </span>
                </v-tooltip>
            </template>
            <template v-slot:item.avg_response_time_minutes="{ item }">
                <span v-if="item.avg_response_time_minutes !== null && item.avg_response_time_minutes !== undefined">
                    {{ formatResponseTime(item.avg_response_time_minutes) }}
                </span>
                <span v-else class="grey--text text--lighten-1">—</span>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-container class="pa-0 ma-0 text-center">
                    <router-link v-if="$can('edit.hotels')"  :to="{name: 'editHotel', params: {id: item.id}}">
                        <v-icon
                            small
                            class="mr-2 edit"
                        >
                            mdi-pencil
                        </v-icon>
                    </router-link>
                    <router-link v-if="$can('manage.hotel-changes')" :to="{name: 'hotelListChanges', params: {id: item.id}}">
                        <v-icon
                            small
                            class="mr-2 changes"
                        >
                            mdi-table-edit
                        </v-icon>
                    </router-link>
                    <v-icon
                        v-if="$can('delete.hotels')"
                        small
                        class="delete"
                        @click="openDeleteHotelModal(item)"
                    >
                        mdi-delete
                    </v-icon>
                </v-container>
            </template>
        </v-data-table>
        <confirm-deletion-modal
            :dialog-active="deleteDialog"
            :dialog-loading="deleteDialogLoading"
            :entity-to-delete="hotelToDelete.name"
            @delete-method="deleteHotel(hotelToDelete.id)"
            @close-dialog="closeDeleteDialog"
        />
    </v-card>
</template>

<script>
import moment from 'moment';
import ConfirmDeletionModal from "../Modals/ConfirmDeletionModal.vue";
import FareExpirationMixin from "../../mixins/Fares/FareExpirationMixin";
import { getMaskedCnpj, getUnmaskedCnpj } from "../../helpers/DocumentHelper";

export default {
    name: "ListHotel",
    components: {ConfirmDeletionModal},
    mixins: [FareExpirationMixin],
    data: () => ({
        dialog: false,
        hotelName: '',
        hotelCity: '',
        created_at: '',
        thisMonth: '',
        until: '',
        creatorName: '',
        loading: true,
        total: 0,
        dateCalendar: [],
        date: '',
        menu1: '',
        active: '',
        expiredRoomFares: '',
        cnpj: '',
        expiredRoomFaresOptions: [
            { text: 'Vigentes', value: 'nonExpired' },
            { text: 'Expiradas', value: 'expired' },
            { text: 'A Expirar', value: 'aboutToExpire' }
        ],
        selects: [
            {text: 'Ativo', value: '1' },
            {text: 'Inativo', value:'0'},
        ],
        options: {
            sortDesc: [true],
        },
        headers: [
            {text: 'Nome', value: 'name'},
            {text: 'Cidade', value: 'city'},
            {text: 'UF', value: 'state', sortable: false},
            {text: 'CNPJ', value: 'cnpj'},
            {text: 'Cadastrado Por', value: 'creator.name', sortable: false},
            {text: 'Cadastrado Em', value: 'created_at'},
            {text: 'Situação do Hotel', value: 'active'},
            {text: 'Última Atualização Em', value: 'updated_at', sortable: false},
            {text: 'Situação das Tarifas', value: 'has_expired_room_fares', sortable: false},
            {text: 'Tempo Médio de Resposta', value: 'avg_response_time_minutes', sortable: true},
            {text: 'Ações', value: 'actions', sortable: false},
        ],
        items: [],
        deleteDialog: '',
        deleteDialogLoading: '',
        hotelToDelete: {},
        expiredRoomFaresFilter: '',
        expiredRoomFaresFilterData: [
            {
                label: 'Vigentes',
                value: 'nonExpired',
                counter: '',
                counterColor: 'success'
            },
            {
                label: 'Expiradas',
                value: 'expired',
                counter: '',
                counterColor: 'warning'
            },
            {
                label: 'A Expirar',
                value: 'aboutToExpire',
                counter: '',
                counterColor: 'yellow'
            }
        ],
        isUpdatingFromExpiredRoomFares: false
    }),
    mounted () {
        this.initializeFilters();
        this.fetchFareCounters();
    },
    methods: {
        getMaskedCnpj,
        parseDate(date, format) {
            return moment(date).format(format);
        },
        formatDate (dateCalendar) {
            if (!dateCalendar) return null

            const [year, month, day] = dateCalendar.split('-')
            return `${day}/${month}/${year}`
        },
        getActive( item){
            if(item.active === 1){
                return "Ativo"
            }
            if(item.active === 0){
                return "Inativo"
            }
        },
        getCleanFilter(){
            this.$router.replace({'query': null});
            window.location.reload();
        },
        getData() {
            this.loading = true;
            const {sortBy, sortDesc, page, itemsPerPage} = this.options;
            const queryParams = {
                sort: sortBy,
                sortDesc: sortDesc,
                page: page,
                perPage: itemsPerPage,
                hotelName: this.hotelName,
                hotelCity: this.hotelCity,
                creatorName: this.creatorName,
                created_at: this.created_at,
                until: this.until,
                thisMonth: this.thisMonth,
                active: this.active,
                expiredRoomFares: this.expiredRoomFares,
                cnpj: getUnmaskedCnpj(this.cnpj),
            };

            this.$router.push({ query: queryParams });

            axios.get('api/hotel/list',{ params: queryParams }).then(res => {
                this.items = res.data.data;
                this.total = res.data.total;
                this.loading = false;
            });
        },
        deleteHotel(id) {
            this.deleteDialogLoading = true;
            axios.delete(`api/hotel/${id}`)
                 .then(() => {
                     window.location.reload();
                     this.$forceUpdate();
                 })
        },
        openDeleteHotelModal(item) {
            this.hotelToDelete = item;
            this.deleteDialog = true;
            this.deleteDialogLoading = false;
        },
        closeDeleteDialog() {
            this.deleteDialog = false;
        },
        getLastUpdateDate(item) {
            if(item.update_histories[0]) {
                let lastUpdateDate = item.update_histories[0].action_date;
                return this.parseDate(lastUpdateDate, 'DD/MM/YYYY H:mm');
            }
            return this.parseDate(item.created_at, 'DD/MM/YYYY H:mm');
        },
        initializeFilters () {
            if (Object.keys(this.$route.query).length) {
                const {
                    sort,
                    sortDesc,
                    page,
                    perPage,
                    hotelName,
                    hotelCity,
                    cnpj,
                    creatorName,
                    created_at,
                    until,
                    thisMonth,
                    active,
                    expiredRoomFares
                } = this.$route.query;

                if (sort) {
                    this.options.sortBy = sort;
                }
                if (sortDesc) {
                    this.options.sortDesc = sortDesc;
                }
                if (page) {
                    this.options.page = parseInt(page ? page : 1);
                }
                if (perPage) {
                    this.options.perPage = perPage;
                }
                if (hotelName) {
                    this.hotelName = hotelName;
                }
                if (hotelCity) {
                    this.hotelCity = hotelCity;
                }
                if (cnpj) {
                    this.cnpj = cnpj;
                }
                if (creatorName) {
                    this.creatorName = creatorName;
                }
                if (created_at) {
                    this.created_at = created_at;
                }
                if (until) {
                    this.until = until;
                }
                if (thisMonth) {
                    this.thisMonth = thisMonth;
                }
                if (active) {
                    this.active = active;
                }
                if (expiredRoomFares) {
                    this.expiredRoomFares = expiredRoomFares;
                }
            }
        },
        async fetchFareCounters () {
            axios.get('api/fares/counter-by-status',{ validateStatus: () => true }).then(response => {
                if (response.status === 200 && response.data) {
                    this.expiredRoomFaresFilterData[0].counter = this.getValueAsString(response.data.nonExpiredFaresCount);
                    this.expiredRoomFaresFilterData[1].counter = this.getValueAsString(response.data.expiredFaresCount);
                    this.expiredRoomFaresFilterData[2].counter = this.getValueAsString(response.data.aboutToExpireFaresCount);
                }
            });
        },
        getValueAsString (value) {
            return String(value);
        },
        formatResponseTime(minutes) {
            if (minutes === null || minutes === undefined) return '—';
            if (minutes < 60) {
                return `${Math.round(minutes)} min`;
            }
            const hours = Math.floor(minutes / 60);
            const mins = Math.round(minutes % 60);
            return mins === 0 ? `${hours}h` : `${hours}h ${mins}min`;
        },
    },
    watch: {
        cnpj(val) {
            if (val && val !== val.toUpperCase()) {
                this.cnpj = val.toUpperCase();
            }
        },
        options: {
            handler() {
                this.getData()
            },
            deep: true,
        },
        dateCalendar() {
           let created_at= this.formatDate(this.dateCalendar[0])
            if (this.dateCalendar[1] != null ){
                let until= this.formatDate(this.dateCalendar[1])
                this.date= created_at + " ate " + until
                this.created_at = this.dateCalendar[0]
                this.until = this.dateCalendar[1]
            }
        },
        expiredRoomFaresFilter (value) {
            if (!this.isUpdatingFromExpiredRoomFares) {
                this.expiredRoomFares = value;
                this.getData();
            }
        },
        expiredRoomFares (value) {
            this.isUpdatingFromExpiredRoomFares = true;
            this.expiredRoomFaresFilter = value;
            this.$nextTick(() => {
                this.isUpdatingFromExpiredRoomFares = false;
            });
        }
    }
}
</script>

<style>
.dataTable {
    border-bottom: 1px solid rgba(0, 0, 0, .12);
    border-radius: 0;
}

.dataTable .v-data-table-header tr th span {
    font-size: 14px !important;
}

.edit:hover {
    color: #009efb;
}

.delete:hover {
    color: #f44336;
}

.changes:hover {
    color: #fbc02d;
}

a {
    text-decoration: none;
}

.filter-btn {
    font-weight: 600;
}

.filter-btn:hover {
    background-color: rgba(25, 118, 210, 0.08) !important;
}
</style>
